export const COLOR_CONSTANTS = {
    '$warning-yellow': '#fa0',
    $outdoor: '#0290a3',
    $indoor: '#5fd0df',
    $shower: '#8cf1f4',
    $toilet: '#8db9a9',
    $softener: '#497969',
    $dishwasher: '#e37b63',
    $clotheswasher: '#6f1a07',
    '$outdoor-prev': '#fec555',
    '$indoor-prev': '#fbe8c1',
    '$shower-prev': '#d3d3d3',
    '$toilet-prev': '#aaa',
    '$softener-prev': '#686868',
    '$dishwasher-prev': '#979797',
    '$clotheswasher-prev': '#313131',
    '$red-clay': '#e34b28',
    $sunset: '#e8863a',
    '$flume-sand': '#ffecdc',
    '$insight-yellow': '#fec555',
    '$insight-yellow-indoor': '#fbe8c1',
    '$insight-yellow-shower': '#fad180',
    '$insight-yellow-toilet': '#fadda4',
    '$insight-yellow-softener': '#fadda4',
    '$dishwasher-pink': '#e37b63',
    '$clotheswasher-red': '#6f1a07',
    '$cut-grass': '#497969',
    '$soft-green': '#8db9a9',
    '$mystic-blue': '#dfe4ed',
    '$ice-blue': '#d1f7f3',
    '$sea-foam-blue': '#d9fdf8',
    '$charolette-blue': '#b4fbf8',
    '$blizzard-blue': '#a5efee',
    '$downy-blue': '#70cad0',
    '$sea-spray-blue': '#8cf1f4',
    '$turquoise-blue': '#6dddea',
    '$scooter-blue': '#40c0dc',
    '$river-blue': '#5fd0df',
    '$curious-blue': '#2e98bd',
    '$irrigation-blue': '#0290a3',
    '$steel-blue': '#4495a2',
    '$matisse-blue': '#20749e',
    '$chathams-blue': '#14547f',
    '$allport-blue': '#1e6071',
    '$blumine-blue': '#175464',
    '$madison-blue': '#0c3c69',
    '$eden-blue': '#104256',
    '$tiber-blue': '#0b3248',
    '$pickled-bluewood': '#2f4050',
    '$biscay-blue': '#293846',
    '$sapphire-blue': '#07243a',
    '$off-white': '#fff',
    '$all-white': '#fff',
    '$smoke-white': '#eee',
    '$athens-gray': '#f8f9fa',
    '$catskill-white': '#edf1f7',
    '$white-lilac': '#f7f9fc',
    '$very-light-gray': '#ccc',
    '$stone-gray': '#d5d5d5',
    '$ghost-gray': '#ced4da',
    '$cadet-blue': '#a7b1c2',
    '$text-muted': '#6c757d',
    '$text-chart': '#666',
    '$black-pearl': '#041a30',
    '$transparent-black': 'rgba(0,0,0,0.26)',
    '$app-background': '#edf1f7',
    '$app-spinner-background': '#fff',
    '$notification-border': '#ccc',
    '$no-notifications-text': '#175464',
    '$location-selection-border': '#edf1f7',
    '$location-selection-background-active': '#5fd0df',
    '$location-selection-background-hover': '#fff',
    '$location-selection-text-active': '#fff',
    '$location-selection-border-inactive': '#f8f9fa',
    '$form-slider-main': '#1e6071',
    '$form-slider-background': 'rgba(0,0,0,0.26)',
    '$form-slider-text': '#fff',
    '$datetime-input-background': '#ffecdc',
    '$datetime-input-border': 'transparent',
    '$datetime-input-border-bottom': 'solid .25rem #5fd0df',
    '$datetime-input-border-focus': '#5fd0df',
    '$datetime-input-text': '#041a30',
    '$settings-header-icon': '#a7b1c2',
    '$settings-header-icon-hover': '#d5d5d5',
    '$primary-location-icon': '#5fd0df',
    '$not-primary-location-icon': '#a7b1c2',
    '$disagg-label-text-enabled': '#fff',
    '$disagg-label-text-disabled': '#041a30',
    '$disagg-label-disabled': '#d5d5d5',
    '$disagg-outdoor-label': '#0290a3',
    '$disagg-indoor-label': '#5fd0df',
    '$disagg-label-border-disabled': '#d5d5d5',
    '$irrigation-line-bg': 'rgba(3,144,163,0.4)',
};
